import { MODALS, EVENTS, STATUS_CODE_OK } from  'common/domain/constants';

class ModalRemovePeriodController {

  constructor($translate, $scope, EventEmitter) {
    'ngInject';
    this.scope = $scope;
    this.translate = $translate;
    this.EventEmitter = EventEmitter;

    this._translate();
    this.scope.$on(EVENTS.CONTEXT_MENU_REMOVE, () => this.openModal());
  }

  $onInit() {
    this.modal.on('hidden.bs.modal', () => this.resetFlags());
  }

  get modal() {
    return angular.element(MODALS.REMOVE_PERIOD);
  }

  _translate() {
    this.translate('VACATIONS_ABSENCES.DELETE_HOLIDAYS_APPROVED.SUCCESS_ACTION.TITLE').then((translation) => {
      this.SUCCESS_TITLE = translation;
    });

    this.translate('VACATIONS_ABSENCES.DELETE_HOLIDAYS_APPROVED.SUCCESS_ACTION.DESCRIPTION').then((translation) => {
      this.SUCCESS_DESCRIPTION = translation;
    });

    this.translate('GLOBALS.BUTTON_ACTION.OK').then((translation) => {
      this.SUCCESS_BUTTON = translation;
    });

    this.translate('VACATIONS_ABSENCES.MODAL_REQUEST_HOLIDAY.ERROR_1').then((translation) => {
      this.errorMsg = translation;
    });

  }

  openModal(){
    this.modal.modal('show');
  }

  startRemoving(){
    return this.success === undefined && this.error=== undefined;
  }

  requestIsSuccessful() {
    return this.success === true;
  }

  requestIsFailed() {
    return this.error === true;
  }

  requestSuccess() {
    this.success = true;
  }

  requestError($event) {
    try {
      this.errorRequestMessage = $event.data.message;
    } catch (err) {
      this.errorRequestMessage = this.errorMsg;
    }

    this.error = true;
  }

  onSelection({status,startDate,endDate}){
    if (status === STATUS_CODE_OK) {

      let response = this.EventEmitter({status, startDate, endDate});
      this.response = response;
      this.requestSuccess();

      if (!this.isMobileApp) {
        this.onRemove(response);
      }
    } else {
      this.requestError();
    }
  }

  onRemoveOnClickSuccess() {
    this.onRemove(this.response);
  }

  onDismiss() {
    this.closeModal();
  }

  closeModal() {
    this.modal.modal('hide');
  }

  resetFlags() {
    this.success = undefined;
    this.error = undefined;
  }

}

export default ModalRemovePeriodController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRemovePeriod/modalRemovePeriod.controller.js